


































import HeaderBase from '../../components/organisms/HeaderBase.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProfielEditButton from '../../components/button/ProfielEditButton.vue';
import { Session } from '../../utils/Session';
import { routeHelper } from '../../utils/routeHelper';
import MaintenunceSelectDialog from './MaintenunceSelectDialog.vue';
import TeacherDocumentListDialog from './TeacherDocumentListDialog.vue';
import { ContextDataServiceExt } from '../../../src_client/biz/ContextDataServiceExt';
import { ContextDTO } from '../../../src_server/entity/dto/ContextDTO';
import { getBuildingName } from '../../../src_server/entity/master/buildingData';

@Component({
  components: {
    ProfielEditButton,
    MaintenunceSelectDialog,
    TeacherDocumentListDialog,
    HeaderBase,
  },
})
export default class TeacherHeaderNavigation extends Vue {
  private context = new ContextDTO();

  @Prop({ default: true })
  public login!: boolean;

  private get notReadingCount() {
    return Session.getContext()?.not_reading_count || 0;
  }

  get logoLink() {
    if (this.login) {
      return `/teacher-dashboard-page?building=${Session.getSessionBuildingId()}`;
    } else {
      return '/';
    }
  }
  get isProfielEditPage() {
    console.log(this.$route.name);
    return this.$route.name === 'AdditionalInputMainPage';
  }

  goProfielEditPage() {
    routeHelper(this, 'AdditionalInputMainPage');
  }
  goProfielREEditPage() {
    const dialog = this.$refs['MaintenunceSelectDialog'] as MaintenunceSelectDialog;
    dialog.show();
  }
  logout() {
    Session.logout();
    this.$router.push('/');
  }

  showDocumentList() {
    (this.$refs['TeacherDocumentListDialog'] as TeacherDocumentListDialog).show();
  }

  gotoLessonMessage() {
    routeHelper(this, 'TeacherMessagesPage');
  }

  async created() {
    if (this.login) {
      // コンテキストを取得
      const contextBiz = new ContextDataServiceExt();
      const context = await contextBiz.getContext();
      if (context) {
        this.context = context;
      }
    }
    if (!Session.isCircleOBuilding()) {
      document.title = `${getBuildingName(Session.getSessionBuildingId())}`;
    }
  }
}
